import { useDeviceType } from '@cian/ui-kit';
import React from 'react';
import { useDispatch } from 'react-redux';

import { openLeaveContactsModal } from '../../actions/leaveContacts/actions';
import { DealStepsSection } from '../../components/DealStepsSection';
import { trackScrollToCallToAction } from '../../utils/analytics/trackScrollToCallToAction';
import { pipe } from '../../utils/pipe';
import { trackChoseRealtorClick } from './tracking';

export const DealStepsSectionContainer = () => {
  const dispatch = useDispatch();
  const onOpenLeaveContactsModal = () => void dispatch(openLeaveContactsModal());

  const deviceType = useDeviceType();

  return (
    <DealStepsSection
      deviceType={deviceType}
      onChoseRealtorClick={pipe(onOpenLeaveContactsModal, trackChoseRealtorClick)}
      onCreateDealClick={pipe(onOpenLeaveContactsModal, () => trackScrollToCallToAction('deal_process'))}
    />
  );
};
